module.exports = __webpack_public_path__ + "img/logo-vertical-white-en.c9125ee4.png";